<template>
  <div class="p-0 m-0" id="header">
    <div id="navbar" class="w-100 border-bottom bg-gray d-flex align-items-center justify-content-center">
      <div class="d-flex justify-content-between px-5 w-100" id="navcontainer">
        <div class="d-flex align-items-center">
          <router-link :to="homeRoute" class="p-0">
            <img :src="logoPath" style="width: 250px" alt="CrimeTime Computerized Criminal Sentence Calculator" />
          </router-link>

          <button class="btn btn-lg btn-secondary border  ml-5 tab-hidden" @click="themeChange">
            <span v-if="!darkMode"><i class="fa-solid fa-lightbulb"></i> Dark</span>
            <span v-else><i class="fa-solid fa-lightbulb"></i> Light </span>
          </button>
        </div>

        <div class="justify-content-end d-flex col-lg-6 align-items-center bg-gray p-0" role="toolbar" aria-label="Toolbar with button groups">
          <div class="tab-hidden">
            <div class="d-flex align-items-center justify-content-evenly" role="group" aria-label="First group" v-if="token?.length > 0 || this.app_token?.length > 0">
              <router-link v-if="casesEnabled" class="mr-5 fs-4 fw-bold nav-bar-item" to="/Cases"> Case List </router-link>
              <router-link v-if="crimeSearchEnabled" class="mr-5 fs-4 fw-bold nav-bar-item" to="/singleSearch"> Crime Search </router-link>

              <!-- <router-link class="fs-4 fw-bold" to="/negotiator">Negotiator</router-link> -->
              <router-link v-if="creditCalculatorEnabled" class="mr-5 fs-4 fw-bold nav-bar-item" to="/creditCalculator"> Credit Calculator </router-link>
              <!-- <router-link class="fs-5 fw-bold" to="/juryInstructions">
                Jury Instructions
              </router-link> -->
            </div>
          </div>

          <div class="dropdown d-flex flex-column" v-if="hasAccessToken">
            <i ref="menuIcon" class="fa-solid fa-user fa-3 menu-icon fs-4" @click="toggleDropDown">
            </i>
          </div>


          <div ref="menu" class="menu d-flex flex-column" v-if="showDropDown">
            <TransitionGroup name="drawerdown">
              <!-- <router-link to="/Cases" class="menu-option m-0 fs-4 w-100">Case List</router-link> -->
              <div v-if="userData && (userData.WhichCounty || userData.WhichAgency || userData.FirstName || userData.LastName)" class="menu-option-name m-0 fs-4 w-100">

                <i v-if="userData.WhichCounty || userData.WhichAgency" class="fa-solid fa-building fs-5 pr-2"></i>

                <i v-else class="fa-solid fa-user fs-5 pr-2"></i>

                <span v-if="userData.WhichCounty || userData.WhichAgency" class="fw-bold fs-5">
                  {{ userData.WhichCounty }} {{ userData.WhichAgency }}
                </span>

                <span v-else-if="userData.FirstName || userData.LastName" class="fw-bold fs-5">
                  {{ userData.FirstName }} {{ userData.LastName }}
                </span>

              </div>

              <router-link to="/myaccount" class="menu-option m-0 fs-5 w-100">My Account</router-link>
              <router-link to="/products" class="menu-option m-0 fs-5 w-100">Other Products</router-link>
              <router-link v-if="crimeSearchEnabled" to="/singleSearch" class="menu-option m-0 fs-5 w-100 tab-show">Crime Search</router-link>
              <router-link v-if="creditCalculatorEnabled" to="/creditCalculator" class="menu-option m-0 fs-5 w-100 tab-show">Credit Calculator</router-link>
              <a class="menu-option m-0 fs-5 float-right w-100 " href="https://placergroup.com" target="_blank">Placergroup.com</a>
              <a class="menu-option m-0 fs-5 float-right w-100 border-bottom-0" @click="signOut">Log out</a>

              </br>

              <span class="fs-6 pl-2 pt-2 pr-2" style="color: gray"> For help contact </span>
              <span class="fs-6 pl-2 mb-2 pr-2" style="color: gray"> support@placergroup.com </span>
            </TransitionGroup>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { PublicClientApplication } from "@azure/msal-browser";
import { isModuleEnabled, getStoredModuleAccess, resolveLandingRoute } from "../../moduleAccess.js";


export default {
  props: ["app_token"],
  data() {
    return {
      token: this.app_token || null,
      themeSelected: "Placer Group",
      darkMode: false,
      logoPath: "/crimetimelogowhitebg.svg",
      showDropDown: false,
      userData: null,
    };
  },
  methods: {
  
    themeChange() {
      if (this.darkMode) {
        // Switch to default (light mode by removing the attribute)
        localStorage.setItem("theme", "default");
        document.documentElement.removeAttribute("data-theme");
        this.darkMode = false;
        this.logoPath = "/crimetimelogowhitebg.svg";
      } else {
        // Switch to dark mode by setting the data-theme attribute
        localStorage.setItem("theme", "dark-mode");
        document.documentElement.setAttribute("data-theme", "dark-mode");
        this.darkMode = true;
        this.logoPath = "/crimetimelogodarkbg.svg";
      }
    },

    goTo(route) {
      this.$router.push({ name: route });
    },

    async signOut() {
      let token = localStorage.getItem("user_token");

      if (token == "" || token === undefined) return false;

     await axios
        .delete(process.env.VUE_APP_ENDPOINT + "/api/auth/logout", {
          headers: { Authorization: `Bearer ` + token },
        })
        .then((data) => {
          // console.log("datadatadata:", data);

          if (data.authorized == true) {
            //this.$emit("user_authorized", this.authorized)

            // console.log("data.tokendata.token:", data.token);
            // console.log("data.tokendata.user_key:", data.key);
            localStorage.setItem("user_token", data.token);
            localStorage.setItem("user_key", data.key);

            this.token = data.token;

            //this.$emit("user_token", this.token)
            this.$emit("params", {
              user_token: this.token,
              user_attr: data.user_attr,
            });
          }
        })
        .catch((error) => {
          this.errorMessage = error;
          // alert("There was an error! : " + error);
        });

      localStorage.setItem("user_token", "");
      localStorage.setItem("user_attr", "");
      localStorage.setItem("user_token", "");
      localStorage.setItem("user_key", "");
      localStorage.setItem("subscription_status", "");
      localStorage.setItem("module_access", "");
      // const msalConfig = {
      //   auth: {
      //     clientId: process.env.VUE_APP_OFFICE_365_SSO_APP_ID,
      //     authority: "https://login.microsoftonline.com/common",
      //   },
      //   cache: {
      //     cacheLocation: "localStorage",
      //   },
      //   redirectUri: `${process.env.VUE_APP_URL}/`,
      // };
      // const msalInstance = new PublicClientApplication(msalConfig);
      // const accounts = msalInstance.getAllAccounts();
      // if (accounts?.length > 0) {
      //   msalInstance.logout();
      // }

      window.location.href = process.env.VUE_APP_URL + "/";
    },

  toggleDropDown() {
    this.showDropDown = !this.showDropDown;
    if (this.showDropDown) {
      document.addEventListener("click", this.handleClickOutside, true);
    } else {
      document.removeEventListener("click", this.handleClickOutside, true);
    }
  },
  
  handleClickOutside(event) {
      if (
        this.$refs.menu &&
        this.$refs.menuIcon &&
        !this.$refs.menu.contains(event.target) &&
        !this.$refs.menuIcon.contains(event.target)
      ) {
        this.showDropDown = false;
        document.removeEventListener("click", this.handleClickOutside, true);
      }
    },
  },
  computed: {
    moduleAccess() {
      return getStoredModuleAccess();
    },
    homeRoute() {
      return resolveLandingRoute(this.moduleAccess);
    },
    casesEnabled() {
      return isModuleEnabled(this.moduleAccess?.availableModules, "cases");
    },
    crimeSearchEnabled() {
      return isModuleEnabled(this.moduleAccess?.availableModules, "crimeSearch");
    },
    creditCalculatorEnabled() {
      return isModuleEnabled(this.moduleAccess?.availableModules, "creditCalculator");
    },
    storedUserData(){
      if (!localStorage.getItem("user_attr")) return null;
      return JSON.parse(localStorage.getItem("user_attr"));
    },
    hasAccessToken(){
      return localStorage.getItem("user_token")?.length > 0;
    },
  },

  mounted(){
    this.userData = this.storedUserData || null;
  },


  beforeMount() {
    this.themeSelected = localStorage.getItem("theme");

    if (this.themeSelected === "dark-mode") {
        document.documentElement.setAttribute("data-theme", "dark-mode");
        this.darkMode = true;
        this.logoPath = "/crimetimelogodarkbg.svg";
    } else {
        document.documentElement.removeAttribute("data-theme");
        this.darkMode = false;
        this.logoPath = "/crimetimelogowhitebg.svg";
    }

    if (!this.token) {
        this.token = localStorage.getItem("user_token");
    }
    this.user_key = localStorage.getItem("user_key");
},



  // beforeMount() {
  //   // console.log(this.token, this.app_token);
  //   this.themeSelected = localStorage.getItem("theme");
  //   if (this.themeSelected !== "Placer Group") {
  //     this.darkMode = true;
  //   }
  //   if (!this.token) {
  //     this.token = localStorage.getItem("user_token");
  //   }
  //   // console.log(this.token, this.app_token);
  //   this.user_key = localStorage.getItem("user_key");
  //   const darkMode = localStorage.getItem("theme");
  //   if (darkMode == "Toms Theme") {
  //     this.darkMode = true;
  //     this.logoPath = "/crimetimelogodarkbg.svg";
  //   }
  // },



  // watch: {
  //   app_token: function (val) {
  //     this.token = val;
  //   },
  // },
  // async created() {
  //   const token = await localStorage.getItem('token');
  //   console.log(token)
  //   this.token = token
  // }
};
</script>

<style scoped>
.container-fluid {
  width: 100%;
}

#navbar {
  height: 10vh;
}

#navcontainer {
  max-width: 1920px;
}

#logo {
  width: 500px;
  height: 100px;
  background-size: 250px;
  min-width: 250px;
  display: block;
  background-color: var(--secondary) !important;
}

.mob-show {
  display: none !important;
}

@media (max-width: 400px) {
  .mob-hidden {
    display: none !important;
  }

  .mob-show {
    display: block !important;
  }

  #logo {
    width: 200px;
    height: 40px;
    background-size: 150px;
    min-width: 150px;
  }
}

.zup {
  position: relative;
  z-index: 10000;
}

.dropdown-item {
  padding: 10px;
}

.bg-gray {
  background-color: var(--secondary) !important;
}

.underline {
  font-weight: 700;
  text-decoration: underline;
}

#logo {
  background-image: url("../../../public/crimetimelogodarkbg.svg");
  background-repeat: no-repeat;
  width: 300px;
}

a {
  color: var(--primary-font) !important;
}

.dropdown-item {
  background-color: var(--primary) !important;
}

.dropdown-item:hover {
  background-color: var(--secondary) !important;
}

.evil-button:hover {
  background-color: var(--primary-font) !important;
  color: var(--primary) !important;
}
.menu {
  position: absolute;
  top: 65px;
  z-index: 1000;
  background-color: var(--primary);
  border: 1px solid var(--primary-font);
  padding: 10px;
  border-radius: 20px;
}

.menu-option {
  padding: 10px;
  color: var(--primary-font);
  /* border-bottom: 1px solid var(--primary-font); */
  font-weight: 400;
}

.menu-option:hover {
  background-color: var(--off-blue);
  color: var(--primary-font);
  cursor: pointer;
  text-decoration: none;
  border-radius: 10px;
}

.menu-option-name{
  padding: 10px;
}

/* 
.nav-bar-item:hover,
.nav-bar-item a:hover {
  background-color: var(--secondary) !important;
  color: var(--primary-font) !important;
  cursor: pointer !important;
} */

.menu-icon {
  background-color: var(--secondary);
  border-radius: 100px;
  padding: 10px;
  border: 2.5px solid var(--border);
}

.menu-icon:hover {
  background-color: var(--off-blue) !important;
  border-color: var(--primary-font) !important;
}


</style>
